import { createFileRoute } from '@tanstack/react-router';
import { ReportingPage } from '@/components/ReportingPage';

export const Route = createFileRoute('/_authenticated/reporting/')({
  component: ReportingPage,
});
